import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'actions'
import { Link } from 'react-router';
import { retrieveLinks } from 'services/navLinks';
import { push } from 'redux-router';

const {
  logout
} = actions;

class MobileNavbar extends Component {
  static propTypes = {
    logout: PropTypes.func,
    role: PropTypes.string,
    user: PropTypes.object,
    logged: PropTypes.bool,
    modalHide: PropTypes.func
  };

  constructor(props) {
    super(props);
  }

  logoutAction = () => {
    this.props.modalHide();
    this.props.logged && this.props.logout();
  }

  navigate = (route) => {
    this.props.modalHide();
    this.props.dispatch(push(route));
  }

  componentDidMount() {
    document.body.classList.add('burger_menu');
  }

  componentWillUnmount() {
    document.body.classList.remove('burger_menu');
  }

  render() {
    const {
      logged,
      role,
      user,
      modalHide
    } = this.props;
    const links = retrieveLinks({
      logged, role, user
    });
    return (
      <div id="myModal" className="modal_menu">
        <div className="modal-content animated zoomIn">
          <div className="modal-header">
            <span className="close" onClick={modalHide}>×</span>
          </div>

          <div className="modal_body nav">
            <div className="modal_logo">
              <a onClick={() => this.navigate('/')}>
                <img src="/assets/img/logo.png" alt="logo" />
              </a>
            </div>
            <ul>
              {links.map(e => (
              <li onClick={() => this.navigate(e.link)}>
                <a>{e.text}</a>
              </li>))
              }
              {logged && <li onClick={this.logoutAction}>
                <a>Logout</a>
              </li>}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    logged: !!(state.users.user && state.session && state.session.token),
    role: state.users.user.role,
    user: state.users.user
  };
}

const mapDispatchToProps = (dispatch) => (
  {
    logout: () => dispatch(logout()),
    dispatch: dispatch
  }
)


export default connect(mapStateToProps, mapDispatchToProps)(MobileNavbar);



/** WEBPACK FOOTER **
 ** ./src/containers/Navbar/MobileNavbar.jsx
 **/